import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY, COLORS } from '@sortlist-frontend/design-system/legacy';

export const RatingBlock = styled.section`
  background-color: transparent;

  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.sm}) {
    background-color: #fff8ed;

    span {
      color: ${COLORS.WARNING_700};
    }
  }
`;

export const RatingHead = styled.section`
  background-color: transparent;

  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.sm}) {
    background-color: #fff8ed;
  }
`;
